"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrimaryContentContainer = exports.PopOverContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.PopOverContainer = styled_components_1.default.div `
  display: ${(props) => (props.isOpen ? 'block' : 'none')};
`;
exports.PrimaryContentContainer = styled_components_1.default.div `
  position: relative;
  width: fit-content;
  cursor: pointer;
`;
